var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3E3F40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 20.8125C22.7607 20.8125 25.4062 18.167 25.4062 14.9062C25.4062 11.6455 22.7607 9 19.5 9C16.2393 9 13.5938 11.6455 13.5938 14.9062C13.5938 18.167 16.2393 20.8125 19.5 20.8125ZM24.75 22.125H22.49C21.5795 22.5434 20.5664 22.7812 19.5 22.7812C18.4336 22.7812 17.4246 22.5434 16.51 22.125H14.25C11.3502 22.125 9 24.4752 9 27.375V28.0312C9 29.1182 9.88184 30 10.9688 30H28.0312C29.1182 30 30 29.1182 30 28.0312V27.375C30 24.4752 27.6498 22.125 24.75 22.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.08215adabdc2e454a5147a2994c08f5a.svg";
export { ForwardRef as ReactComponent };